import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasTabsComponent } from './container/gas-tabs.component';
import { GasTabComponent } from './tab/gas-tab.component';
import { GasTabDirective } from './tab/gas-tab.directive';

const COMPONENTS = [
  GasTabsComponent,
  GasTabComponent,
];

const DIRECTIVES = [
  GasTabDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasTabsModule { }
